import React from "react";
import { MenuItem as MenuItemProps } from "../../../types/Menu";
import { Box } from "../../Box";
import { Flex } from "../../Flex";
import { MenuItemLink } from "../../MenuItemLink";

export const DropRightHeader: React.FC<MenuItemProps> = ({ title, url }) => (
  <MenuItemLink to={url} color="primary">
    <Flex justifyContent="space-between" align-items="center" px={3}>
      <Box>{title}</Box>
      <Box />
    </Flex>
  </MenuItemLink>
);
